
<!--页面废弃，直接使用客户列表页面-->
<template>
      <Page :title="title">
                <van-list
                  v-model="loading"
                  :finished="finished"
                  :immediate-check="false"
                  finished-text="没有更多了"
                  @load="onLoad"
                  >
            <div class="clientAssign">
                  <!-- 顶部筛选栏   输入框  搜索 -->
                  <div class="header-titile-all">
                        <div class="searchTitle-top-header flex">
                              <div class="searchTitle-top">
                                    <div class="picker-alls" v-if="''" @click="pickerClient">全部
                                          <div class="triangle_border_down"></div>
                                    </div>
                                    <div class="flex input-search-flex">
                                          <input
                                                type="text"
                                                placeholder="客户姓名/手机"
                                                class="search_input"
                                                v-model="inputValue"
                                          >
                                          <img
                                                :src="require('@/assets/img/search.png')"
                                                class="search-img"
                                                alt=""
                                          >
                                    </div>
                              </div>
                              <div class="filtrate-list flex" @click="searchFilter">
                                    <img
                                          :src="require('@/assets/img/filtrate.png')"
                                          class="filtrate-img"
                                          alt=""
                                    >
                                    <div>筛选</div>
                              </div>
                        </div>
                        <!-- 筛选列表区域 -->
                        <div class="flex filtrate-lists-area flexJ">
                              <van-checkbox
                                    v-model="allCheckbox"
                                    checked-color="#0076FF"
                                    @click="allCheckbox_(allCheckbox)"
                              ></van-checkbox>
                              <div
                                    class="flex filtrate-lists-area-item"
                                    v-for="(item,index) in filtrateList"
                                    v-bind:key="index"
                              >
                                    <div>{{item.name}}</div>
                                    <div class="triangle">
                                          <div class="triangle_border_up"></div>
                                          <div class="triangle_border_down"></div>
                                    </div>
                              </div>
                        </div>
                  </div>
                  <!-- 滑动区域 -->
                  <div class="scroll-view">
                        <van-list
                              v-model="loading"
                              :finished="finished"
                              finished-text="没有更多了"
                              @load="onLoad"
                        >
                              <div
                                    class="scroll-view-list-item"
                                    v-for="(item,index) in list"
                                    v-bind:key="index"
                              >
                                    <!-- 内容版块 -->
                                    <div class="select-lists">
                                          <van-checkbox v-model="item.edit" checked-color="#0076FF"></van-checkbox>
                                          <div>
                                          </div>
                                          <div class="information-list">
                                                                  <div class="information-list-item">客户姓名：{{item.custName||''}}</div>
                                                                  <div class="information-list-item">联系方式：{{item.mobile||''}}</div>
                                                                  <div class="information-list-item">预计购买日期: {{item.planDate?item.planDate.split(' ')[0]:''}}</div>
                                                                  <div class="information-list-item">最近购买日期: {{item.buyDate||''}}</div>
                                                                  <div class="information-list-item">最近跟进日期: {{item.followDate||''}}</div>
                                          </div>
                                          <!-- 快捷操作 -->
                                          <div class="operation">
                                                <img
                                                      :src="require('@/assets/img/vipStar.png')"
                                                      class="vipStars"
                                                      v-for="(item,index)   in  item.vipStar"
                                                      v-bind:key="index"
                                                      alt=""
                                                >
                                          </div>
                                    </div>
                              </div>
                        </van-list>
                  </div>
                  <!-- 筛选 -->
                  <van-popup v-model="show" position="bottom" :overlay="true">
                        <van-picker
                              show-toolbar
                              title=""
                              :columns="columnsCode"
                              @cancel="onCancelCode"
                              @confirm="onConfirmCode"
                              class="van-picker-li"
                        />
                  </van-popup>
                  <!-- 分派按钮 -->
                  <div class="toAssign">
                        <div class="toAssign-button" @click="toAssign">分派</div>
                  </div>
            </div>
            </van-list>
      </Page>
</template>




<script>
export default {
  data() {
    return {
      title: "待分派客户列表",
      filtrateList: [
        { name: "VIP等级", edit: false, statue: 0 },
        { name: "预计购买日期", edit: false, statue: 0 },
        { name: "最近购买日期", edit: false, statue: 0 },
        { name: "跟进日期", edit: false, statue: 0 }
      ],
      list: [
        {
          name: "王晓海",
          phone: "15929005711",
          predictBuyTime: "2018.05.10",
          latelyBuyTime: "2018.02.25",
          followDate: "2019.02.19",
          vipStar: 5,
          edit: false
        },
        {
          name: "王晓海",
          phone: "15929005711",
          predictBuyTime: "2018.05.10",
          latelyBuyTime: "2018.02.25",
          followDate: "2019.02.19",
          vipStar: 5,
          edit: false
        },
        {
          name: "王晓海",
          phone: "15929005711",
          predictBuyTime: "2018.05.10",
          latelyBuyTime: "2018.02.25",
          followDate: "2019.02.19",
          vipStar: 5,
          edit: false
        },
        {
          name: "王晓海",
          phone: "15929005711",
          predictBuyTime: "2018.05.10",
          latelyBuyTime: "2018.02.25",
          followDate: "2019.02.19",
          vipStar: 5,
          edit: false
        },
        {
          name: "王晓海",
          phone: "15929005711",
          predictBuyTime: "2018.05.10",
          latelyBuyTime: "2018.02.25",
          followDate: "2019.02.19",
          vipStar: 5,
          edit: false
        }
      ],
      allCheckbox: false, // 是否全选
      columnsCode: ["全部"], //  上拉菜单展示内容
      show: false,
      loading: false,
      finished: false,
      inputValue:"",  //输入框值
      loading: false,
      finished: false,
            /**********  查询字段  **********/
      pageNumber:1,
      pageSize:10,
      queryParam:"",
      sortCol:"", // 排序字段
      sortType:"", // 升序-降序
      courseStartDate:"",
      courseEndDate:"",
      courseId:"",
      registerStartDate:"",
      registerEndDate:"",
      campaignId:"",
      intention:"",
      purchaseStartDate:"",
      purchaseEndDate:"",
      custName:"",
      mobile:"",
      birthdayStartDate:"",
      birthdayEndDate:"",
      vipLevel:"",
      member:"",
      custType:"",
      shootingType:"",
      hobby:"",
      weddingStartDate:"",
      weddingEndDate:"",
      selectDeptId:"",
      selectSalesId:"",
    };
  },
  methods: {
    onCancelCode() {},
    onConfirmCode() {},
    pickerClient() {
      this.show = true;
    },
    /**
     *  高级搜索
     */
    searchFilter() {
      console.log("筛选");
      // this.filtersShow=true
      this.$router.push({ path: "/Filter", query: {} });
    },
    /**
     * 分派
     */
    toAssign() {
      this.show = true;
      this.columnsCode = ["销售顾问1", "销售顾问2"];
    },
    /**
     *
     *  下拉加载
     *
     **/

    onLoad() {
            console.log("到底； ")
            if(this.list.length>4){
                             this.loading=true
                             let $list   =[];
                                 $list   =this.list;
                              //    this.list=$list.concat(this.list)
            }
            // this.finished=true
    },
    /**
     * 选中全部
     */
    allCheckbox_(val) {
      // let $list = [];
      // $list = this.list;
      // if (val == true) {
      //   for (let i = 0; i < $list.length; i++) {
      //     $list[i]["edit"] = true;
      //   }
      //   this.list = $list;
      // } else if(val==false){
      //   for (let i = 0; i < $list.length; i++) {
      //     $list[i]["edit"] = false;
      //   }
      //   this.list = $list;
      // }
    },
        /**
     *
     *  查询客户列表
     *  @param {String}  salesId       销售用户ID
     *  @param {String}  queryParam    列表查询条件，手机号或者客户姓名 高级搜索该字段不需要传
     *  @param {Number}  pageNumber    分页页码
     *  @param {Number}  pageSize      分页每页条数
     *  @param {String}  sortCol
     *  排序字段   多个排序可以以半角英文逗号分隔
        vipLevel      ：    VIP等级
        planDate,     ：   预计购买时间
        buyDate,      ：   购买日期
        followDate    ：   跟进日期
        @param {String}  sortType         排序类型( asc : 升序, desc : 降序)
        @param {String}  courseStartDate  课程时间段  开始时间
        @param {String}  courseEndDate    课程时间段  结束时间
        @param {String}  courseId         课程ID
        @param {String}  registerStartDate   参加活动 开始时间
        @param {String}  registerEndDate     参加活动 结束时间
        @param {String}  campaignId          活动ID
        @param {String}  intention           购买意向
        @param {String}  purchaseStartDate   产品购买时间 开始时间
        @param {String}  purchaseEndDate     产品购买时间 结束时间
        @param {String}  custName            客户姓名
        @param {String}  mobile              手机号码
        @param {String}  birthdayStartDate   客户生日 开始时间
        @param {String}  birthdayEndDate     客户生日 结束时间
        @param {String}  vipLevel            VIP 等级
        @param {String}  member              徕卡会员
        @param {String}  custType            客户类型
        @param {String}  shootingType        摄影主题
        @param {String}  hobby               兴趣爱好
        @param {String}  weddingStartDate    结婚纪念日 开始时间
        @param {String}  weddingEndDate      结婚纪念日 结束时间
        @param {String}  selectDeptId        查询部门
        @param {String}  selectSalesId       查询销售用户


     *
     **/
    getClientlist(ID,Page){
          let data={};
              data['salesId']=this.$wxuserUtil.getUserId();
              data['queryParam']=this.queryParam;
              data['pageNumber']=Page;
              data['pageSize']=this.pageSize;
              data['sortCol']=this.sortCol;
              data['sortType']=this.sortType;
              data['courseStartDate']=this.courseStartDate;
              data['courseEndDate']=this.courseEndDate;
              data['courseId']=this.courseId;
              data['registerStartDate']=this.registerStartDate;
              data['registerEndDate']=this.registerEndDate;
              data['campaignId']=this.campaignId;
              data['intention']=this.intention;
              data['purchaseStartDate']=this.purchaseStartDate;
              data['purchaseEndDate']=this.purchaseEndDate;
              data['custName']=this.custName;
              data['mobile']=this.mobile;
              data['birthdayStartDate']=this.birthdayStartDate;
              data['birthdayEndDate']=this.birthdayEndDate;
              data['vipLevel']=this.vipLevel;
              data['member']=this.member;
              data['custType']=this.custType;
              data['shootingType']=this.shootingType;
              data['hobby']=this.hobby;
              data['weddingStartDate']=this.weddingStartDate;
              data['selectDeptId']=this.selectDeptId;
              data['selectSalesId']=this.selectSalesId;

          this.$api.getClientlist(data).then(Response=>{

              if(ID==1){
                        this.list=Response.data.list;
                        this.totalRow=Response.data.totalRow;
              }
              if(ID==2){
                    let $list  = this.list.concat(Response.data.list);
                    this.list=$list;
                    if(Response.data.list.length==0){
                      this.finished = true;
                    }
              }
       })
    },
    onLoad() {
      setTimeout(() => {
        this.pageNumber= parseInt(this.pageNumber+1)
        this.getClientlist(2,this.pageNumber)
        this.loading = false;
      }, 500);
    },
  },
  mounted() {
         /**
         *  初始化页面数据
         */
         this.getClientlist(1,this.pageNumber)
  },
  watch: {},
  created() {}
};
</script>

<style lang="less"  src="~p/pageView-stayClient.less" scoped>
</style>




// WEBPACK FOOTER //
// src/components/client/stayClient.vue